/**
 * FctFormSection — agrupa campos de formulario bajo un título visualmente
 * destacado con la línea de acento corporativa verde.
 *
 * Uso:
 *   <Form layout="vertical">
 *     <FctFormSection title="Datos del titular">
 *       <Form.Item name="nombre" label="Nombre">
 *         <Input />
 *       </Form.Item>
 *       ...
 *     </FctFormSection>
 *
 *     <FctFormSection title="Datos de la farmacia" description="...">
 *       ...
 *     </FctFormSection>
 *   </Form>
 *
 * La idea es estructurar formularios largos (típicos del CRM GdGo! o de
 * Gescom) en bloques visualmente diferenciados, sin caer en wizards
 * complejos.
 */

import React from 'react';
import { Typography } from 'antd';
import { fctColors } from '../../theme/theme';

const { Title, Paragraph } = Typography;

interface FctFormSectionProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  /** Si en `true`, no se renderiza el separador inferior. */
  noDivider?: boolean;
}

export const FctFormSection: React.FC<FctFormSectionProps> = ({
  title,
  description,
  children,
  noDivider = false,
}) => {
  return (
    <section
      style={{
        marginBottom: noDivider ? 0 : 32,
        paddingBottom: noDivider ? 0 : 24,
        borderBottom: noDivider ? 'none' : `1px solid ${fctColors.grisBorde}`,
      }}
    >
      <div
        style={{
          marginBottom: 16,
          paddingLeft: 12,
          borderLeft: `4px solid ${fctColors.verdeCorporativo}`,
        }}
      >
        <Title level={4} style={{ margin: 0, color: fctColors.negroCorporativo }}>
          {title}
        </Title>
        {description && (
          <Paragraph
            style={{
              margin: '4px 0 0 0',
              color: fctColors.grisCorporativo,
              fontSize: 13,
            }}
          >
            {description}
          </Paragraph>
        )}
      </div>
      {children}
    </section>
  );
};
